import React from 'react';
import './GalleryItem.css';

import { FaPlus } from 'react-icons/fa';

// Import PhotoView from react-photo-view
import { PhotoView } from 'react-photo-view';



const GalleryItem = (props) => {

  // Destructuring props
  const { id, image, title, category, className } = props;

  return (
    <div className={`gallery-item ${className}`} key={id}>
      <div className="gallery-content">

        {/* Gallery Image */}
        <img src={image} alt={title} />

        {/* Gallery Content */}
        <div className='content'>

          <div className='text'>
            <p>{category}</p> {/* Gallery Category */}
            <h3>{title}</h3> {/* Gallery Title */}
          </div>

          {/* Plus icon for lightbox */}
          <PhotoView src={image}>
            <div className='view'>
              <div className='icon'><FaPlus /></div>
            </div>
          </PhotoView>

        </div>

      </div>
    </div>
  );
};

export default GalleryItem;